import { render, staticRenderFns } from "./ActiveCalls.vue?vue&type=template&id=302170d6&scoped=true"
import script from "./ActiveCalls.vue?vue&type=script&lang=ts"
export * from "./ActiveCalls.vue?vue&type=script&lang=ts"
import style0 from "./ActiveCalls.vue?vue&type=style&index=0&id=302170d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302170d6",
  null
  
)

export default component.exports